import { render, staticRenderFns } from "./QueueChart.vue?vue&type=template&id=fb35bd0e&scoped=true"
import script from "./QueueChart.vue?vue&type=script&lang=js"
export * from "./QueueChart.vue?vue&type=script&lang=js"
import style0 from "./QueueChart.vue?vue&type=style&index=0&id=fb35bd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb35bd0e",
  null
  
)

export default component.exports